import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, purpleMui, rydeColors, ScreenDepth } from "@ryde/theme";

/** Anchors the display-mode toggle over a ride map. Always pinned to the physical left edge (LTR + RTL). Parent map container must be positioned. */
export const MapDisplayModeOverlayStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "map-display-mode-overlay",
})`
  position: absolute;
  top: 130px;
  left: 12px /* @noflip */;
  z-index: ${ScreenDepth.MAP_ATTRIBUTIONS};
`;

export const LiveMapDisplayModeDropdownWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "live-map-display-mode-dropdown",
  },
)`
  position: relative;
  display: inline-flex;
  align-items: center;

  .live-map-display-mode-popper {
    z-index: ${ScreenDepth.FLOATING_MENU};
  }

  .live-map-display-mode-trigger {
    width: 32px;
    min-width: 32px;
    height: 32px;
    padding: 0;
    border: 1px solid ${greyMui._300};
    border-radius: 4px;
    background-color: ${rydeColors.white};
    color: ${rydeColors.black};
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;

    &:hover {
      background-color: ${rydeColors.focusedOption};
    }

    /* PanelStatStyled applies margin on bare svg — reset inside the trigger */
    svg {
      margin: 0;
      flex-shrink: 0;
    }

    .live-map-display-mode-icon {
      width: 15px;
      height: 20px;
      display: block;
    }

    .live-map-display-mode-icon--muted {
      color: ${greyMui._500};
    }

    .live-map-display-mode-icon--active {
      color: ${purpleMui._600};
    }
  }

  .live-map-display-mode-dropdown-item {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 220px;
    padding-block: 10px;
    padding-inline: 12px;
  }

  .live-map-display-mode-dropdown-item__label {
    font-size: 13px;
    line-height: 1.3;
    color: ${rydeColors.black};
  }

  .live-map-display-mode-preview {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${greyMui._300};
    border-radius: 4px;
    background-color: ${rydeColors.white};
    line-height: 0;

    svg {
      margin: 0;
    }
  }

  .live-map-display-mode-preview__image {
    width: 12px;
    height: 16px;
    display: block;
    margin: 0;
  }

  .live-map-display-mode-preview .live-map-display-mode-icon--muted {
    color: ${greyMui._500};
  }

  .live-map-display-mode-preview .live-map-display-mode-icon--active {
    color: ${purpleMui._600};
  }
`;
